var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBanquet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1182 10.625C14.4436 10.625 13.9939 11.3 13.9939 11.75V17.375H11.7454V11.75C11.7454 11.075 11.2957 10.625 10.6212 10.625C9.94665 10.625 9.49696 11.3 9.49696 11.75V17.375H7.24848V11.75C7.24848 11.075 6.79878 10.625 6.12424 10.625C5.4497 10.625 5 11.3 5 11.75V19.175C5 21.2 6.57394 22.775 8.37272 23V38.75C8.37272 40.1 9.27211 41 10.6212 41C11.9703 41 12.8697 40.1 12.8697 38.75V23C14.6685 22.775 16.2424 21.2 16.2424 19.175V11.75C16.2424 11.3 15.7927 10.625 15.1182 10.625ZM19.6151 11.75V25.25H21.8636V38.75C21.8636 40.1 22.763 41 24.1121 41C25.4612 41 26.3605 40.1 26.3605 38.75V5C22.5381 5 19.6151 7.925 19.6151 11.75ZM35.3545 9.5C32.2066 9.5 29.7333 12.875 29.7333 16.925C29.5084 19.625 30.8575 22.1 33.106 23.675V38.75C33.106 40.1 34.0054 41 35.3545 41C36.7035 41 37.6029 40.1 37.6029 38.75V23.675C39.8514 22.1 41.2005 19.625 40.9757 16.925C40.9757 12.875 38.5023 9.5 35.3545 9.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanquet);
export default __webpack_public_path__ + "static/media/banquet.e3343d9efd8ded4a8d4f4c9f1526d1e2.svg";
export { ForwardRef as ReactComponent };